import { AccountsRequests } from '@/services/accounts.requests'
import Vue from 'vue'
const accountService = new AccountsRequests()

const state = {
  account: null,
  userAccounts: [],
}

const getters = {
  getGuestAccount: (state, getters) => (guest) => {
    const { accountId, room, booking } = guest.guest
    return accountId || (
      room && room.accountId
        ? room.accountId
        : booking
          ? booking.accountId
          : null
    )
  },
}

const actions = {
  getAccount ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      accountService.getAccount(id).then((account) => {
        commit('setAccount', account)
        resolve(account)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  listMyAccounts ({ state, dispatch, rootGetters }) {
    state.userAccounts = []
    const promises = []
    rootGetters['me/accounts'].forEach(({ id }) => {
      promises.push(dispatch('getAccount', { id }).then((account) => {
        state.userAccounts.push(account)
        return account
      }))
    })
    return Promise.all(promises)
  },
}

const mutations = {
  setAccount (state, account) {
    Vue.set(state, 'account', account)
  },
  resetAccount (state) {
    Vue.set(state, 'account', null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
